import { z } from 'zod';
import { apiGet, apiSend } from '@/lib/api';

/**
 * WSTRZYMANE ZDJĘCIA — masowe usunięcia z jednej maszyny, które czekają na decyzję człowieka.
 * Skąd się biorą: `api/src/agent-ingest/bezpiecznik-usuniec.ts`.
 *
 * ⚠️ `rodzaj` JAKO NAPIS, NIE `enum`. Nowy rodzaj po stronie serwera nie może wywrócić całego
 * panelu — ekran pokaże go wtedy jako „wiersze", a decyzja dalej zadziała.
 */
export const WstrzymaneSchema = z.object({
  wstrzymane: z.array(
    z.object({
      id: z.string(),
      nodeId: z.string(),
      maszyna: z.string().nullable(),
      tabela: z.string(),
      od: z.string(),
      rodzaj: z.string().nullable(),
      wierszy: z.number(),
      cele: z.array(z.object({ nazwa: z.string(), wierszy: z.number() })),
      zmiany: z.array(z.object({ numer: z.string(), osoba: z.string().nullable(), cel: z.string() })),
      obcietych: z.number(),
    }),
  ),
});

export type Wstrzymanie = z.infer<typeof WstrzymaneSchema>['wstrzymane'][number];

export const fetchWstrzymane = (groupId: string) =>
  apiGet(`/wstrzymane-usuniecia?groupId=${encodeURIComponent(groupId)}`, WstrzymaneSchema);

const DecyzjaSchema = z.object({ zakolejkowanych: z.number() });

/** „Roześlij" — zdjąć we wszystkich bazach wyspy i w portalu. */
export const rozeslijWstrzymane = (groupId: string, id: string) =>
  apiSend('POST', `/wstrzymane-usuniecia/${encodeURIComponent(id)}/rozeslij`, { groupId }, DecyzjaSchema);

/** „Przywróć" — wiersze wracają na maszynę, która je zdjęła. */
export const przywrocWstrzymane = (groupId: string, id: string) =>
  apiSend('POST', `/wstrzymane-usuniecia/${encodeURIComponent(id)}/przywroc`, { groupId }, DecyzjaSchema);
